// One number and what it is, for the compute strip.
//
// The note that used to ride on a native `title` is a hover card now: every one
// of these five numbers means nothing without the sentence saying what it is a
// median *of*, and a browser tooltip a second late in the system font was where
// those sentences lived.

import type { ReactNode } from "react";

import { HoverCard, styled, Text } from "../kit";

const Stack = styled("div")({
  display: "flex",
  flexDirection: "column",
  cursor: "help"
});

export function Figure({
  label,
  value,
  note
}: {
  label: string;
  value: string;
  note: ReactNode;
}): React.ReactElement {
  return (
    <HoverCard placement="bottom" title={label} card={note} maxWidth={320}>
      <Stack>
        <Text role="display" weight={700} size={20}>
          {value}
        </Text>
        <Text tone="dim" size={11}>
          {label}
        </Text>
      </Stack>
    </HoverCard>
  );
}
